import React, { useEffect, useState } from 'react';
import { Button, Card, CardTitle } from 'lib/releox-react';
import { PrintURL } from '../../classes/PrintURL';

export default () => {
  const [started, setStarted] = useState(false);

  useEffect(() => {
    if (!started) return undefined;
    const timeout = setTimeout(() => setStarted(false), 5000);
    return () => clearTimeout(timeout);
  }, [started]);

  const onDownload = () => {
    setStarted(true);
    // Open as a plain link so the browser streams the file to disk instead of keeping it in memory
    window.open(PrintURL.getClientExportUrl(), '_blank');
  };

  return (
    <div className="col-md-6 offset-3">
      <Card>
        <CardTitle>Client export</CardTitle>
        <p>
          Download all clients as a CSV file. Each row contains the client&apos;s name, phone
          number, address on one line and country.
        </p>
        <p className="text-muted">
          The file is semicolon separated (UTF-8) and opens directly in Excel. With a lot of clients
          the download can take a moment, follow it in your browser&apos;s downloads.
        </p>
        <Button
          id="download-client-csv"
          type="button"
          onClick={onDownload}
          disabled={started}
          disabledText="Download started..."
        >
          Download CSV
        </Button>
      </Card>
    </div>
  );
};
